const initialState = {
  mainThemes: [],
  subThemes: []
};

export default function skillsReducer(state = initialState, action) {
  switch (action.type) {
    default: {
      return state;
    }
  }
}
